import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=1eb38bfe&"
import script from "./OrderTable.ts?vue&type=script&lang=ts&"
export * from "./OrderTable.ts?vue&type=script&lang=ts&"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=1eb38bfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports